export default __webpack_public_path__ + "static/media/25081107.59a8a90c.png";